import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ServicesOrder = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://demo-two.keytime.sa/api/order/servecies")
      .then((response) => {
        setOrders(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div className="container mx-auto p-4">
     
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">اسم العميل</th>
            <th className="border p-2">رقم الجوال</th>
            <th className="border p-2">البريد الإلكتروني</th>
            <th className="border p-2">اسم الخدمة</th>
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders.map((order, index) => (
              <tr key={index} className="text-center">
                <td className="border p-2">{order.name}</td>
                <td className="border p-2">{order.number}</td>
                <td className="border p-2">{order.email}</td>
                <td className="border p-2">{order.serveicename}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center p-4">
                لا توجد بيانات متاحة
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ServicesOrder;
